import React, { useEffect, useState } from "react";
import { Formik, Field, ErrorMessage, Form } from "formik";
import * as Yup from "yup";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getPostsById } from "../../../../redux/posts/action";
import { postContestEntry } from "../../../../redux/contest/action";
import { descriptionvalidation, titlevalidation } from "../../../Common/commonvalidation";
import AllTypeFilesUpload from "../../../Common/Upload/AllTypeFilesUpload";
import AsteriskLabel from "../../../Common/AsteriskLabel";
import HomeCommonNavigation from "../../../Common/HomeCommonNavigation";

export default function SubmitContestEntry() {
  const path = "Assets/scss/searchcontestparticipate.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);
  const [work_sample, setWork_sample] = useState();
  const [loading, setLoading] = useState(false);

  const laung = localStorage.getItem("laung") || "en";
  const [lan, setLan] = useState(laung);
  const navigate = useNavigate();
  const { id } = useParams();
  const posts = useSelector(({ posts: { postbyid } }) => postbyid);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getPostsById(id));
  }, [id, dispatch]);

  const initialValues = {
    message: "",
    title: "",
    licensed: "",
    files: "",
  };

  const validationSchema = Yup.object().shape({
    message: descriptionvalidation,
    title: titlevalidation,
    licensed: Yup.string()
      .oneOf(["1", "2"], "Licensed content is required")
      .required("Licensed content is required"),
    files: Yup.array().test(
      "files-required",
      "At least one file is required",
      (value) => {
        return value && value.length > 0;
      },
    ),
  });

  const handleSubmit = (values) => {
    const data = {
      ...values,
      files: work_sample?.files,
      post_id: posts.id,
      type: 2,
      url: `/${lan}/praposedsuccessful`,
    };
    dispatch(postContestEntry(data, setLoading, navigate));
  };

  useEffect(() => {
    setWork_sample(work_sample);
  }, [work_sample]);

  useEffect(() => {
    if (Array.isArray(posts?.my_proposal) && posts?.my_proposal?.length > 0) {
      navigate(`/${lan}/contestdetails/${posts.id}`);
    }
  }, [posts, posts?.my_proposal, posts?.my_proposal?.length]);

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {(formik) => (
        <Form className="project-details col-lg-10 mx-auto">
          <p className="breadcrumbs">
            {/* <a onClick={() => navigate(`/${lan}/searchall`)}>Home &gt; </a> */}
            <HomeCommonNavigation type={posts?.type} />
            <a onClick={() => navigate(`/${lan}/contestdetails/${posts.id}`)}>
              WBO details &gt;
            </a>
            Submit entry
          </p>
          { }
          <div className="col-lg-10  mx-auto ">
            <div className="submit-entry">
              <h5>Submit entry</h5>
              <h2>{posts.title}</h2>
              <div className="col-lg-8 mx-auto">
                <h6>Add files <AsteriskLabel /></h6>

                <AllTypeFilesUpload
                  formik={formik}
                  setWork_sample={setWork_sample}
                  selectedfiles={work_sample?.files}
                />
                {formik.errors.files && (
                  <p style={{ color: "red", fontSize: 16 }}>
                    {formik.errors.files}
                  </p>
                )}
                <div className="form-group">
                  <label>Entry Title <AsteriskLabel /></label>
                  <Field
                    type="text"
                    className="form-control"
                    name="title"
                    placeholder="Enter entry title"
                  />
                  <ErrorMessage
                    name="title"
                    component="div"
                    className="error"
                  />
                </div>
                <div className="form-group">
                  <label>Description <AsteriskLabel /></label>
                  <Field
                    as="textarea"
                    className="form-control"
                    name="message"
                    placeholder="Enter description here"
                  />
                  <ErrorMessage
                    name="message"
                    component="div"
                    className="error"
                  />
                </div>
                <h6 className="license">Licensed Content <AsteriskLabel /></h6>
                <p>Declare any stock content used to avoid penalty.</p>
                {/* <div className="checkbox-label ">
                  <label className="checkbox-container">
                    <input name="iam" type="radio" value="1" />
                    <span className="checkmark">This entry is entirely my own.</span>
                  </label>
                  <label className="checkbox-container">
                    <input name="iam" type="radio" value="1" />
                    <span className="checkmark">This entry contains elements I did not create.</span>
                  </label>
                </div> */}
                <div className="radio-btn">
                  <Field type="radio" id="entry" name="licensed" value="1" />
                  <label htmlFor="entry">This entry is entirely my own.</label>
                </div>
                <div className="radio-btn">
                  <Field type="radio" id="element" name="licensed" value="2" />
                  <label htmlFor="element">
                    This entry contains elements I did not create.
                  </label>
                </div>
                <ErrorMessage
                  name="licensed"
                  component="div"
                  className="error"
                />
              </div>
            </div>
            <div className="entry-btn">
              <button
                type="button"
                className="btn"
                onClick={() => navigate(`/${lan}/contestdetails/${posts.id}`)}
              >
                Cancel
              </button>
              <button type="submit" className="btn">
                Submit entry
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/common/right-arrow.svg`}
                  alt=""
                />
              </button>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
}
